import {
  legacyMaturaSeoRedirects,
  maturaSeoTopicRegistry,
} from "./maturaSeoTopicRegistry";
import { basicSchoolSeoTopicRegistry } from "./basicSchoolSeoTopicRegistry";
import { expandedSeoTopicRegistry } from "./expandedSeoTopicRegistry";

export { legacyMaturaSeoRedirects };

export const seoTopicRegistry = [
  {
    slug: "wzory-skroconego-mnozenia",
    lessonId: "2_1_2",
    title: "Wzory skr\u00F3conego mno\u017Cenia",
    useRealTheory: true,
    seoNote:
      "W tym temacie nauczysz si\u0119 najwa\u017Cniejszych wzor\u00F3w skr\u00F3conego mno\u017Cenia i ich praktycznego zastosowania w zadaniach.",
    modeGuide: {
      theory:
        "W teorii i przyk\u0142adach zobaczysz najwa\u017Cniejsze wzory oraz krok po kroku, jak poprawnie je stosowa\u0107.",
      practice:
        "W \u0107wiczeniach prze\u0107wiczysz rozwijanie i upraszczanie wyra\u017Ce\u0144 na wielu wariantach zada\u0144.",
      quiz:
        "W quizie szybko sprawdzisz, czy opanowa\u0142e\u015B temat i kt\u00F3re typy zada\u0144 warto jeszcze utrwali\u0107.",
    },
    faq: [
      {
        q: "Co to są wzory skróconego mnożenia?",
        a: "To zestaw wzorów, które pozwalają szybciej rozwinąć nawiasy i uprościć wyrażenia algebraiczne.",
      },
      {
        q: "Jak rozwinąć kwadrat sumy (a+b)²?",
        a: "Stosujemy wzór: (a+b)² = a² + 2ab + b².",
      },
      {
        q: "Jak rozwinąć kwadrat różnicy (a-b)²?",
        a: "Stosujemy wzór: (a-b)² = a² - 2ab + b².",
      },
      {
        q: "Jak działa różnica kwadratów a² - b²?",
        a: "Równanie można zapisać jako iloczyn: a² - b² = (a-b)(a+b).",
      },
      {
        q: "Czy (a+b)² = a² + b²?",
        a: "Nie. Poprawny wzór zawiera składnik 2ab, więc (a+b)² = a² + 2ab + b².",
      },
    ],
    accordionContent: {
      theory: [
        "Wzory skróconego mnożenia pozwalają szybko rozkładać i upraszczać wyrażenia algebraiczne.",
        "Najczęściej używane schematy to: (a+b)^2, (a-b)^2 oraz (a+b)(a-b).",
        "W praktyce warto najpierw rozpoznać schemat, a dopiero potem wykonywać mnożenie krok po kroku.",
      ],
      examples: [
        "(x+3)^2 = x^2 + 6x + 9",
        "(2x-5)^2 = 4x^2 - 20x + 25",
        "(3x+1)(3x-1) = 9x^2 - 1",
      ],
      practice: [
        "W ćwiczeniach przechodzisz przez wiele wariantów: rozwijanie, zwijanie i upraszczanie wyrażeń.",
        "Po każdym zadaniu możesz losować kolejne przykłady i utrwalać schematy.",
      ],
      quiz: [
        "Quiz sprawdza rozpoznawanie wzorów i poprawne przekształcenia.",
        "Po zakończeniu dostajesz wynik i szybki obraz, co warto jeszcze dopracować.",
      ],
    },
  },
  {
    slug: "wzory-skroconego-mnozenia-zadania",
    lessonId: "2_1_2",
    title: "Wzory skróconego mnożenia - zadania",
    useRealTheory: false,
    directPartIndex: 1,
    seoNote:
      "Zadania ze wzorów skróconego mnożenia w trybie demo. Ćwicz od razu bez przechodzenia przez ekran wyboru.",
  },
  {
    slug: "rownania-liniowe",
    lessonId: "2_2_1",
    title: "R\u00F3wnania liniowe",
    useRealTheory: true,
    faq: [
      {
        q: "Co to jest r\u00F3wnanie liniowe?",
        a: "R\u00F3wnanie liniowe to r\u00F3wnanie z jedn\u0105 niewiadom\u0105 pierwszego stopnia, kt\u00F3re mo\u017Cna zapisa\u0107 w postaci ax + b = 0.",
      },
      {
        q: "Jak rozwi\u0105za\u0107 r\u00F3wnanie liniowe krok po kroku?",
        a: "Upraszczamy obie strony, przenosimy wyrazy z x na jedn\u0105 stron\u0119, liczby na drug\u0105 i dzielimy przez wsp\u00F3\u0142czynnik przy x.",
      },
      {
        q: "Kiedy r\u00F3wnanie liniowe ma jedno rozwi\u0105zanie, a kiedy brak lub niesko\u0144czenie wiele?",
        a: "Jedno rozwi\u0105zanie jest wtedy, gdy po przekszta\u0142ceniach otrzymujemy x = liczba. Brak rozwi\u0105za\u0144 mamy przy sprzeczno\u015Bci typu 0 = 5, a niesko\u0144czenie wiele rozwi\u0105za\u0144 przy to\u017Csamo\u015Bci typu 0 = 0.",
      },
      {
        q: "Jak rozwi\u0105zywa\u0107 r\u00F3wnania liniowe z nawiasami?",
        a: "Najpierw wymna\u017Camy nawiasy, potem redukujemy wyrazy podobne i rozwi\u0105zujemy r\u00F3wnanie jak standardowe r\u00F3wnanie liniowe.",
      },
      {
        q: "Jak sprawdzi\u0107, czy wynik r\u00F3wnania liniowego jest poprawny?",
        a: "Podstawiamy otrzymane x do r\u00F3wnania pocz\u0105tkowego i sprawdzamy, czy lewa strona jest r\u00F3wna prawej stronie.",
      },
    ],
  },
  {
    slug: "rownania-kwadratowe",
    lessonId: "2_2_2",
    title: "R\u00F3wnania kwadratowe",
    useRealTheory: true,
    faq: [
      {
        q: "Co to jest r\u00F3wnanie kwadratowe?",
        a: "R\u00F3wnanie kwadratowe to r\u00F3wnanie jednej niewiadomej w postaci ax\u00B2 + bx + c = 0, gdzie a jest r\u00F3\u017Cne od 0.",
      },
      {
        q: "Jak obliczy\u0107 delt\u0119 w r\u00F3wnaniu kwadratowym?",
        a: "Delt\u0119 liczymy ze wzoru: $\\Delta=b^2-4ac$. Potem na jej podstawie wyznaczamy liczb\u0119 rozwi\u0105za\u0144.",
      },
      {
        q: "Ile rozwi\u0105za\u0144 ma r\u00F3wnanie kwadratowe w zale\u017Cno\u015Bci od delty?",
        a: "Gdy \u0394 > 0 s\u0105 dwa rozwi\u0105zania, gdy \u0394 = 0 jest jedno rozwi\u0105zanie podw\u00F3jne, a gdy \u0394 < 0 nie ma rozwi\u0105za\u0144 rzeczywistych.",
      },
      {
        q: "Jak wyznaczy\u0107 miejsca zerowe r\u00F3wnania kwadratowego?",
        a: "Dla $\\Delta\\ge 0$ korzystamy ze wzor\u00F3w: $x_1=\\frac{-b-\\sqrt{\\Delta}}{2a}$, $x_2=\\frac{-b+\\sqrt{\\Delta}}{2a}$. Przy $\\Delta=0$ oba wzory daj\u0105 ten sam wynik.",
      },
      {
        q: "Jak rozwi\u0105zywa\u0107 niepe\u0142ne r\u00F3wnania kwadratowe?",
        a: "Najpierw wy\u0142\u0105czamy wsp\u00F3lny czynnik lub przenosimy wyrazy, a potem stosujemy rozk\u0142ad na iloczyn albo pierwiastkowanie, zale\u017Cnie od postaci.",
      },
    ],
  },
  {
    slug: "nierownosci-liniowe",
    lessonId: "2_3_1",
    title: "Nier\u00F3wno\u015Bci liniowe",
    useRealTheory: true,
    faq: [
      {
        q: "Co to jest nier\u00F3wno\u015B\u0107 liniowa?",
        a: "Nier\u00F3wno\u015B\u0107 liniowa to nier\u00F3wno\u015B\u0107 z jedn\u0105 niewiadom\u0105 pierwszego stopnia, kt\u00F3r\u0105 mo\u017Cna sprowadzi\u0107 do postaci ax + b > 0, ax + b < 0, ax + b >= 0 lub ax + b <= 0.",
      },
      {
        q: "Jak rozwi\u0105za\u0107 nier\u00F3wno\u015B\u0107 liniow\u0105 krok po kroku?",
        a: "Upraszczamy obie strony, przenosimy wyrazy z x na jedn\u0105 stron\u0119, liczby na drug\u0105, a na ko\u0144cu dzielimy przez wsp\u00F3\u0142czynnik przy x.",
      },
      {
        q: "Kiedy trzeba zmieni\u0107 znak nier\u00F3wno\u015Bci?",
        a: "Znak nier\u00F3wno\u015Bci odwracamy tylko wtedy, gdy mno\u017Cymy lub dzielimy obie strony przez liczb\u0119 ujemn\u0105.",
      },
      {
        q: "Jak zapisa\u0107 rozwi\u0105zanie nier\u00F3wno\u015Bci liniowej?",
        a: "Rozwi\u0105zanie zapisujemy jako warunek na x (np. x > 3) oraz w postaci przedzia\u0142u, np. (3, +\u221E).",
      },
      {
        q: "Jakie s\u0105 najcz\u0119stsze b\u0142\u0119dy przy nier\u00F3wno\u015Bciach liniowych?",
        a: "Najcz\u0119stsze b\u0142\u0119dy to brak zmiany znaku po dzieleniu przez liczb\u0119 ujemn\u0105 i b\u0142\u0119dne przepisanie granicy przedzia\u0142u.",
      },
    ],
  },
  {
    slug: "nierownosci-kwadratowe",
    lessonId: "2_3_2",
    title: "Nier\u00F3wno\u015Bci kwadratowe",
    useRealTheory: true,
    faq: [
      {
        q: "Co to jest nier\u00F3wno\u015B\u0107 kwadratowa?",
        a: "To nier\u00F3wno\u015B\u0107, kt\u00F3r\u0105 mo\u017Cna zapisa\u0107 w postaci $ax^2+bx+c>0$, $<0$, $\\ge 0$ lub $\\le 0$, gdzie $a\\ne 0$.",
      },
      {
        q: "Jak rozwi\u0105za\u0107 nier\u00F3wno\u015B\u0107 kwadratow\u0105 krok po kroku?",
        a: "Najpierw wyznaczamy miejsca zerowe tr\u00F3jmianu, potem badamy znak wyra\u017Cenia na przedzia\u0142ach i wybieramy te zgodne z nier\u00F3wno\u015Bci\u0105.",
      },
      {
        q: "Jak\u0105 rol\u0119 pe\u0142ni delta przy nier\u00F3wno\u015Bciach kwadratowych?",
        a: "Delta pomaga okre\u015Bli\u0107 liczb\u0119 miejsc zerowych, a to decyduje, jak dzielimy o\u015B i gdzie zmienia si\u0119 znak tr\u00F3jmianu.",
      },
      {
        q: "Kiedy u\u017Cywa\u0107 nawiasu domkni\u0119tego w zapisie przedzia\u0142u?",
        a: "Gdy nier\u00F3wno\u015B\u0107 jest nieostra ($\\ge$ lub $\\le$), punkty zerowe nale\u017C\u0105 do rozwi\u0105zania i zapisujemy je nawiasem domkni\u0119tym.",
      },
      {
        q: "Jaki b\u0142\u0105d najcz\u0119\u015Bciej pojawia si\u0119 przy nier\u00F3wno\u015Bciach kwadratowych?",
        a: "Najcz\u0119\u015Bciej myli si\u0119 przedzia\u0142y dodatnie i ujemne albo pomija w\u0142a\u015Bciwe domkni\u0119cie punkt\u00F3w zerowych.",
      },
    ],
  },
  {
    slug: "funkcja-liniowa",
    lessonId: "3_2_1",
    title: "Funkcja liniowa",
    courseTopicCode: "3.2.1",
    useRealTheory: true,
    faq: [
      {
        q: "Co to jest funkcja liniowa?",
        a: "Funkcja liniowa ma posta\u0107 $f(x)=ax+b$, gdzie $a$ i $b$ s\u0105 liczbami rzeczywistymi.",
      },
      {
        q: "Jak odczyta\u0107 wsp\u00F3\u0142czynnik kierunkowy i wyraz wolny?",
        a: "Wz\u00F3r $f(x)=ax+b$ ma wsp\u00F3\u0142czynnik kierunkowy $a$ i wyraz wolny $b$, czyli punkt przeci\u0119cia z osi\u0105 $OY$.",
      },
      {
        q: "Kiedy funkcja liniowa jest rosn\u0105ca, a kiedy malej\u0105ca?",
        a: "Funkcja jest rosn\u0105ca, gdy $a>0$, malej\u0105ca, gdy $a<0$, a sta\u0142a, gdy $a=0$.",
      },
      {
        q: "Jak wyznaczy\u0107 miejsce zerowe funkcji liniowej?",
        a: "Miejsce zerowe liczymy z r\u00F3wnania $ax+b=0$, czyli $x_0=-\\frac{b}{a}$ dla $a\\ne 0$.",
      },
      {
        q: "Jaki b\u0142\u0105d najcz\u0119\u015Bciej pojawia si\u0119 przy funkcji liniowej?",
        a: "Najcz\u0119\u015Bciej myli si\u0119 znak przy $b$ oraz b\u0142\u0119dnie odczytuje nachylenie prostej z wykresu.",
      },
    ],
  },
  {
    slug: "funkcja-kwadratowa",
    lessonId: "3_3_1",
    title: "Funkcja kwadratowa",
    courseTopicCode: "3.3.2",
    useRealTheory: true,
    faq: [
      {
        q: "Co to jest funkcja kwadratowa?",
        a: "Funkcja kwadratowa ma posta\u0107 $f(x)=ax^2+bx+c$, gdzie $a\\ne 0$. Jej wykres to parabola.",
      },
      {
        q: "Jak odczyta\u0107, w kt\u00F3r\u0105 stron\u0119 skierowane s\u0105 ramiona paraboli?",
        a: "Je\u015Bli a > 0, ramiona paraboli s\u0105 skierowane w g\u00F3r\u0119. Je\u015Bli a < 0, ramiona s\u0105 skierowane w d\u00F3\u0142.",
      },
      {
        q: "Jak wyznaczy\u0107 wierzcho\u0142ek paraboli?",
        a: "Wsp\u00F3\u0142rz\u0119dna $x$ wierzcho\u0142ka to $x_w=\\frac{-b}{2a}$, a wsp\u00F3\u0142rz\u0119dna $y$ to $y_w=f(x_w)$.",
      },
      {
        q: "Jak okre\u015Bli\u0107 zbi\u00F3r warto\u015Bci funkcji kwadratowej?",
        a: "Zbi\u00F3r warto\u015Bci wynika z po\u0142o\u017Cenia wierzcho\u0142ka i kierunku ramion: dla a > 0 jest od ymin do +\u221E, a dla a < 0 od -\u221E do ymax.",
      },
      {
        q: "Czym r\u00F3\u017Cni si\u0119 funkcja kwadratowa od r\u00F3wnania kwadratowego?",
        a: "Funkcja opisuje ca\u0142y wykres i jej w\u0142asno\u015Bci, a r\u00F3wnanie kwadratowe dotyczy szukania konkretnych $x$ spe\u0142niaj\u0105cych warunek $ax^2+bx+c=0$.",
      },
    ],
  },
  {
    slug: "twierdzenie-pitagorasa",
    lessonId: "6_1_4",
    title: "Twierdzenie Pitagorasa",
    useRealTheory: true,
    faq: [
      {
        q: "Co m\u00F3wi twierdzenie Pitagorasa?",
        a: "W tr\u00F3jk\u0105cie prostok\u0105tnym suma kwadrat\u00F3w przyprostok\u0105tnych jest r\u00F3wna kwadratowi przeciwprostok\u0105tnej: $a^2+b^2=c^2$.",
      },
      {
        q: "Kiedy mo\u017Cna stosowa\u0107 twierdzenie Pitagorasa?",
        a: "Twierdzenie Pitagorasa stosujemy tylko w tr\u00F3jk\u0105tach prostok\u0105tnych.",
      },
      {
        q: "Jak obliczy\u0107 przeciwprostok\u0105tn\u0105?",
        a: "Je\u015Bli znamy przyprostok\u0105tne $a$ i $b$, to przeciwprostok\u0105tna wynosi $c=\\sqrt{a^2+b^2}$.",
      },
      {
        q: "Jak obliczy\u0107 przyprostok\u0105tn\u0105, gdy znamy przeciwprostok\u0105tn\u0105?",
        a: "Przekszta\u0142camy wz\u00F3r do postaci, np. $a=\\sqrt{c^2-b^2}$.",
      },
      {
        q: "Jaki jest najcz\u0119stszy b\u0142\u0105d przy zadaniach z Pitagorasem?",
        a: "Najcz\u0119stszy b\u0142\u0105d to podstawienie bok\u00F3w w z\u0142e miejsca i traktowanie przeciwprostok\u0105tnej jak przyprostok\u0105tnej.",
      },
    ],
  },
  {
    slug: "trojkat-prostokatny",
    lessonId: "6_1_4",
    title: "Tr\u00F3jk\u0105t prostok\u0105tny",
    useRealTheory: true,
    faq: [
      {
        q: "Co to jest tr\u00F3jk\u0105t prostok\u0105tny?",
        a: "To tr\u00F3jk\u0105t, kt\u00F3ry ma jeden k\u0105t prosty, czyli $90^\\circ$.",
      },
      {
        q: "Jak nazwa\u0107 boki w tr\u00F3jk\u0105cie prostok\u0105tnym?",
        a: "Bok naprzeciw k\u0105ta prostego to przeciwprostok\u0105tna, a dwa pozosta\u0142e to przyprostok\u0105tne.",
      },
      {
        q: "Jak obliczy\u0107 brakuj\u0105cy bok tr\u00F3jk\u0105ta prostok\u0105tnego?",
        a: "Najcz\u0119\u015Bciej korzystamy z twierdzenia Pitagorasa: $a^2+b^2=c^2$.",
      },
      {
        q: "Kiedy w zadaniach o tr\u00F3jk\u0105cie prostok\u0105tnym u\u017Cywa si\u0119 trygonometrii?",
        a: "Gdy znamy k\u0105t i jeden bok albo dwa boki i chcemy wyznaczy\u0107 k\u0105t lub brakuj\u0105cy bok.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej?",
        a: "Najcz\u0119\u015Bciej myli si\u0119 przeciwprostok\u0105tn\u0105 z przyprostok\u0105tn\u0105 i podstawia z\u0142e dane do wzoru.",
      },
    ],
  },
  {
    slug: "pole-trojkata",
    lessonId: "6_1_2",
    title: "Pole tr\u00F3jk\u0105ta",
    useRealTheory: true,
    faq: [
      {
        q: "Jaki jest podstawowy wz\u00F3r na pole tr\u00F3jk\u0105ta?",
        a: "Pole tr\u00F3jk\u0105ta liczymy ze wzoru $P=\\frac{a\\cdot h}{2}$.",
      },
      {
        q: "Co oznacza wysoko\u015B\u0107 w tr\u00F3jk\u0105cie?",
        a: "Wysoko\u015B\u0107 to odcinek prostopad\u0142y do boku (lub jego przed\u0142u\u017Cenia), poprowadzony z przeciwleg\u0142ego wierzcho\u0142ka.",
      },
      {
        q: "Jak obliczy\u0107 pole tr\u00F3jk\u0105ta prostok\u0105tnego?",
        a: "Dla przyprostok\u0105tnych $a$ i $b$ mamy $P=\\frac{a\\cdot b}{2}$.",
      },
      {
        q: "Czy pole tr\u00F3jk\u0105ta zale\u017Cy od wyboru podstawy?",
        a: "Nie, niezale\u017Cnie od wybranej podstawy i odpowiadaj\u0105cej jej wysoko\u015Bci pole wychodzi takie samo.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej przy polu tr\u00F3jk\u0105ta?",
        a: "Najcz\u0119\u015Bciej zapomina si\u0119 podzieli\u0107 przez $2$ albo myli wysoko\u015B\u0107 z bokiem.",
      },
    ],
  },
  {
    slug: "potegi-naturalne",
    lessonId: "1_4_1",
    title: "Pot\u0119gi o wyk\u0142adniku naturalnym",
    useRealTheory: true,
    faq: [
      {
        q: "Co oznacza pot\u0119ga o wyk\u0142adniku naturalnym?",
        a: "Pot\u0119ga $a^n$ oznacza iloczyn $n$ jednakowych czynnik\u00F3w r\u00F3wnych $a$.",
      },
      {
        q: "Jakie s\u0105 podstawowe wzory na pot\u0119gi?",
        a: "Najwa\u017Cniejsze to: $a^m\\cdot a^n=a^{m+n}$, $\\frac{a^m}{a^n}=a^{m-n}$, $(a^m)^n=a^{mn}$.",
      },
      {
        q: "Jak oblicza\u0107 pot\u0119gi z liczbami ujemnymi?",
        a: "Przy wyk\u0142adniku parzystym wynik jest dodatni, a przy nieparzystym zachowuje znak liczby ujemnej.",
      },
      {
        q: "Ile wynosi dowolna liczba do pot\u0119gi zerowej?",
        a: "Dla $a\\ne 0$ mamy $a^0=1$.",
      },
      {
        q: "Jaki b\u0142\u0105d najcz\u0119\u015Bciej pojawia si\u0119 przy pot\u0119gach?",
        a: "Najcz\u0119\u015Bciej myli si\u0119 dodawanie wyk\u0142adnik\u00F3w przy mno\u017Ceniu z mno\u017Ceniem wyk\u0142adnik\u00F3w.",
      },
    ],
  },
  {
    slug: "notacja-wykladnicza",
    lessonId: "1_4_4",
    title: "Notacja wyk\u0142adnicza",
    useRealTheory: true,
    faq: [
      {
        q: "Co to jest notacja wyk\u0142adnicza?",
        a: "To zapis liczby w postaci $a\\cdot 10^n$, gdzie $1\\le |a|<10$ i $n\\in\\mathbb{Z}$.",
      },
      {
        q: "Jak zapisa\u0107 du\u017C\u0105 liczb\u0119 w notacji wyk\u0142adniczej?",
        a: "Przesuwamy przecinek tak, aby otrzyma\u0107 liczb\u0119 od 1 do 10 i liczb\u0119 przesuni\u0119\u0107 zapisujemy jako wyk\u0142adnik dodatni.",
      },
      {
        q: "Jak zapisa\u0107 ma\u0142\u0105 liczb\u0119 w notacji wyk\u0142adniczej?",
        a: "Przesuwamy przecinek w prawo do liczby od 1 do 10, a wyk\u0142adnik jest wtedy ujemny.",
      },
      {
        q: "Jak mno\u017Cy\u0107 liczby w notacji wyk\u0142adniczej?",
        a: "Mno\u017Cymy cz\u0119\u015Bci dziesi\u0119tne i dodajemy wyk\u0142adniki pot\u0119g dziesi\u0119ciu, potem normalizujemy zapis.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej?",
        a: "Najcz\u0119\u015Bciej zostawia si\u0119 cz\u0119\u015B\u0107 dziesi\u0119tn\u0105 poza zakresem $[1,10)$ i nie normalizuje wyniku.",
      },
    ],
  },
  {
    slug: "wlasnosci-logarytmow",
    lessonId: "1_5_2",
    title: "W\u0142asno\u015Bci logarytm\u00F3w",
    useRealTheory: true,
    faq: [
      {
        q: "Jakie s\u0105 podstawowe w\u0142asno\u015Bci logarytm\u00F3w?",
        a: "Najwa\u017Cniejsze to: $\\log_a(xy)=\\log_a x+\\log_a y$, $\\log_a\\frac{x}{y}=\\log_a x-\\log_a y$, $\\log_a(x^k)=k\\log_a x$.",
      },
      {
        q: "Kiedy logarytm jest okre\u015Blony?",
        a: "Musi by\u0107 spe\u0142nione: podstawa $a>0$, $a\\ne 1$ oraz argument $x>0$.",
      },
      {
        q: "Ile wynosi logarytm z jedynki?",
        a: "Dla ka\u017Cdej dopuszczalnej podstawy mamy $\\log_a 1=0$.",
      },
      {
        q: "Ile wynosi logarytm liczby r\u00F3wnej podstawie?",
        a: "Mamy $\\log_a a=1$.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej przy logarytmach?",
        a: "Najcz\u0119\u015Bciej zapomina si\u0119 o warunkach dziedziny i wykonuje przekszta\u0142cenia dla niedozwolonych argument\u00F3w.",
      },
    ],
  },
  {
    slug: "obliczanie-logarytmow",
    lessonId: "1_5_3",
    title: "Obliczanie logarytm\u00F3w",
    useRealTheory: true,
    faq: [
      {
        q: "Jak obliczy\u0107 logarytm krok po kroku?",
        a: "Szukamy wyk\u0142adnika, do kt\u00F3rego trzeba podnie\u015B\u0107 podstaw\u0119, aby otrzyma\u0107 argument.",
      },
      {
        q: "Jak obliczy\u0107 logarytm bez kalkulatora?",
        a: "Najcz\u0119\u015Bciej przepisujemy argument jako pot\u0119g\u0119 podstawy i korzystamy z definicji logarytmu.",
      },
      {
        q: "Ile wynosi $\\log_a a^k$?",
        a: "Mamy bezpo\u015Brednio $\\log_a a^k = k$ (dla poprawnych warunk\u00F3w na podstaw\u0119).",
      },
      {
        q: "Czy mo\u017Cna oblicza\u0107 logarytm z liczby ujemnej?",
        a: "Nie, w liczbach rzeczywistych argument logarytmu musi by\u0107 dodatni.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej przy obliczaniu logarytm\u00F3w?",
        a: "Najcz\u0119\u015Bciej pomija si\u0119 warunki dziedziny albo myli argument z podstaw\u0105.",
      },
    ],
  },
  {
    slug: "nwd-i-nww",
    lessonId: "1_3_3",
    title: "NWD i NWW",
    useRealTheory: true,
    faq: [
      {
        q: "Co to jest NWD i NWW?",
        a: "NWD to najwi\u0119kszy wsp\u00F3lny dzielnik, a NWW to najmniejsza wsp\u00F3lna wielokrotno\u015B\u0107 liczb.",
      },
      {
        q: "Jak obliczy\u0107 NWD dw\u00F3ch liczb?",
        a: "Mo\u017Cna u\u017Cy\u0107 rozk\u0142adu na czynniki pierwsze albo algorytmu Euklidesa.",
      },
      {
        q: "Jak obliczy\u0107 NWW dw\u00F3ch liczb?",
        a: "Mo\u017Cna skorzysta\u0107 ze wzoru $NWW(a,b)=\\frac{a\\cdot b}{NWD(a,b)}$ dla liczb dodatnich.",
      },
      {
        q: "Jaki jest zwi\u0105zek mi\u0119dzy NWD i NWW?",
        a: "Dla dw\u00F3ch liczb dodatnich iloczyn NWD i NWW jest r\u00F3wny iloczynowi tych liczb.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej?",
        a: "Najcz\u0119\u015Bciej myli si\u0119 definicje dzielnika i wielokrotno\u015Bci albo gubi pot\u0119gi liczb pierwszych.",
      },
    ],
  },
  {
    slug: "obliczanie-procentow",
    lessonId: "1_2_1",
    title: "Obliczanie procent\u00F3w",
    useRealTheory: true,
    faq: [
      {
        q: "Jak obliczy\u0107 procent z liczby?",
        a: "Mno\u017Cymy liczb\u0119 przez procent zapisany jako u\u0142amek dziesi\u0119tny, np. $15\\%$ z $200$ to $0{,}15\\cdot 200=30$.",
      },
      {
        q: "Jak obliczy\u0107, ile procent stanowi jedna liczba z drugiej?",
        a: "Dzielimy cz\u0119\u015B\u0107 przez ca\u0142o\u015B\u0107 i mno\u017Cymy przez $100\\%$.",
      },
      {
        q: "Jak obliczy\u0107 podwy\u017Ck\u0119 o procent?",
        a: "Mno\u017Cymy warto\u015B\u0107 pocz\u0105tkow\u0105 przez $1+p$, gdzie $p$ to procent w zapisie dziesi\u0119tnym.",
      },
      {
        q: "Jak obliczy\u0107 obni\u017Ck\u0119 o procent?",
        a: "Mno\u017Cymy warto\u015B\u0107 pocz\u0105tkow\u0105 przez $1-p$, gdzie $p$ to procent w zapisie dziesi\u0119tnym.",
      },
      {
        q: "Jaki b\u0142\u0105d najcz\u0119\u015Bciej pojawia si\u0119 przy procentach?",
        a: "Najcz\u0119\u015Bciej myli si\u0119 zapis procentu i zamiast $0{,}2$ wpisuje $20$.",
      },
    ],
  },
  {
    slug: "wartosc-bezwzgledna",
    lessonId: "1_1_2",
    title: "Warto\u015B\u0107 bezwzgl\u0119dna",
    useRealTheory: true,
    faq: [
      {
        q: "Co to jest warto\u015B\u0107 bezwzgl\u0119dna?",
        a: "Warto\u015B\u0107 bezwzgl\u0119dna liczby to jej odleg\u0142o\u015B\u0107 od zera na osi liczbowej.",
      },
      {
        q: "Ile wynosi warto\u015B\u0107 bezwzgl\u0119dna liczby ujemnej?",
        a: "Dla liczby ujemnej wynik jest dodatni, np. $|-7|=7$.",
      },
      {
        q: "Jak rozwi\u0105zywa\u0107 r\u00F3wnania z warto\u015Bci\u0105 bezwzgl\u0119dn\u0105?",
        a: "Rozbijamy na dwa przypadki: wyra\u017Cenie pod kreskami jest r\u00F3wne liczbie dodatniej albo jej liczbie przeciwnej.",
      },
      {
        q: "Jak rozwi\u0105zywa\u0107 nier\u00F3wno\u015Bci z warto\u015Bci\u0105 bezwzgl\u0119dn\u0105?",
        a: "Interpretujemy je geometrycznie jako odleg\u0142o\u015B\u0107 od punktu i zapisujemy odpowiedni przedzia\u0142 lub sum\u0119 przedzia\u0142\u00F3w.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej?",
        a: "Najcz\u0119\u015Bciej pomija si\u0119 drugi przypadek z minusem i przez to traci po\u0142ow\u0119 rozwi\u0105za\u0144.",
      },
    ],
  },
  {
    slug: "zbiory-liczbowe",
    lessonId: "1_1_3",
    title: "Zbiory",
    useRealTheory: true,
    faq: [
      {
        q: "Jakie s\u0105 podstawowe zbiory liczbowe?",
        a: "Najcz\u0119\u015Bciej u\u017Cywamy: naturalnych $\\mathbb{N}$, ca\u0142kowitych $\\mathbb{Z}$, wymiernych $\\mathbb{Q}$ i rzeczywistych $\\mathbb{R}$.",
      },
      {
        q: "Czym r\u00F3\u017Cni\u0105 si\u0119 liczby wymierne od niewymiernych?",
        a: "Wymierne mo\u017Cna zapisa\u0107 jako u\u0142amek $\\frac{p}{q}$, a niewymiernych nie da si\u0119 tak zapisa\u0107.",
      },
      {
        q: "Co oznaczaj\u0105 symbole $\\subset$ i $\\in$?",
        a: "$A\\subset B$ oznacza, \u017Ce zbi\u00F3r $A$ zawiera si\u0119 w $B$, a $x\\in A$ \u2014 \u017Ce element $x$ nale\u017Cy do zbioru $A$.",
      },
      {
        q: "Jak rozpozna\u0107, do jakiego zbioru nale\u017Cy liczba?",
        a: "Sprawdzamy jej posta\u0107 i w\u0142asno\u015Bci, np. czy jest ca\u0142kowita, czy ma sko\u0144czone/okresowe rozwini\u0119cie dziesi\u0119tne.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej przy zbiorach?",
        a: "Najcz\u0119\u015Bciej myli si\u0119 symbol elementu ze zbiorem i zapisuje np. $\\mathbb{N}\\in\\mathbb{R}$ zamiast $\\mathbb{N}\\subset\\mathbb{R}$.",
      },
    ],
  },
  {
    slug: "przedzialy-liczbowe",
    lessonId: "1_1_4",
    title: "Przedzia\u0142y",
    useRealTheory: true,
    faq: [
      {
        q: "Co to jest przedzia\u0142 liczbowy?",
        a: "To zbi\u00F3r liczb rzeczywistych mi\u0119dzy dwiema granicami, z okre\u015Bleniem czy ko\u0144ce nale\u017C\u0105 do zbioru.",
      },
      {
        q: "Czym r\u00F3\u017Cni si\u0119 nawias okr\u0105g\u0142y od kwadratowego?",
        a: "Nawias okr\u0105g\u0142y oznacza brak kra\u0144ca w zbiorze, a kwadratowy \u2014 \u017Ce kraniec nale\u017Cy do przedzia\u0142u.",
      },
      {
        q: "Jak zapisa\u0107 nier\u00F3wno\u015B\u0107 w postaci przedzia\u0142u?",
        a: "Przepisujemy warunek na $x$ jako zakres liczb, np. $x>3$ to przedzia\u0142 $(3,+\\infty)$.",
      },
      {
        q: "Jak odczytywa\u0107 sum\u0119 i cz\u0119\u015B\u0107 wsp\u00F3ln\u0105 przedzia\u0142\u00F3w?",
        a: "Suma zawiera liczby nale\u017C\u0105ce do co najmniej jednego przedzia\u0142u, a cz\u0119\u015B\u0107 wsp\u00F3lna tylko te wsp\u00F3lne dla obu.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej?",
        a: "Najcz\u0119\u015Bciej myli si\u0119 domkni\u0119cie kra\u0144c\u00F3w i u\u017Cywa z\u0142ych nawias\u00F3w przy nier\u00F3wno\u015Bciach ostrych/nieostrych.",
      },
    ],
  },
  {
    slug: "ciag-arytmetyczny",
    lessonId: "4_2_1",
    title: "Ci\u0105g arytmetyczny",
    useRealTheory: true,
    faq: [
      {
        q: "Co to jest ci\u0105g arytmetyczny?",
        a: "To ci\u0105g, w kt\u00F3rym r\u00F3\u017Cnica mi\u0119dzy kolejnymi wyrazami jest sta\u0142a i r\u00F3wna $r$.",
      },
      {
        q: "Jaki jest wz\u00F3r na n-ty wyraz ci\u0105gu arytmetycznego?",
        a: "Korzystamy ze wzoru $a_n=a_1+(n-1)r$.",
      },
      {
        q: "Jak wyznaczy\u0107 r\u00F3\u017Cnic\u0119 ci\u0105gu arytmetycznego?",
        a: "Odejmujemy s\u0105siednie wyrazy, np. $r=a_2-a_1$.",
      },
      {
        q: "Kiedy ci\u0105g arytmetyczny jest rosn\u0105cy?",
        a: "Jest rosn\u0105cy, gdy $r>0$, malej\u0105cy gdy $r<0$, a sta\u0142y gdy $r=0$.",
      },
      {
        q: "Jaki b\u0142\u0105d najcz\u0119\u015Bciej pojawia si\u0119 przy ci\u0105gu arytmetycznym?",
        a: "Najcz\u0119\u015Bciej myli si\u0119 numer wyrazu i zapisuje $a_n=a_1+nr$ zamiast $a_1+(n-1)r$.",
      },
    ],
  },
  {
    slug: "ciag-geometryczny",
    lessonId: "4_3_1",
    title: "Ci\u0105g geometryczny",
    useRealTheory: true,
    faq: [
      {
        q: "Co to jest ci\u0105g geometryczny?",
        a: "To ci\u0105g, w kt\u00F3rym iloraz kolejnych wyraz\u00F3w jest sta\u0142y i r\u00F3wny $q$.",
      },
      {
        q: "Jaki jest wz\u00F3r na n-ty wyraz ci\u0105gu geometrycznego?",
        a: "Stosujemy wz\u00F3r $a_n=a_1\\cdot q^{n-1}$.",
      },
      {
        q: "Jak obliczy\u0107 iloraz ci\u0105gu geometrycznego?",
        a: "Dzielimy kolejne wyrazy, np. $q=\\frac{a_2}{a_1}$ (gdy $a_1\\ne 0$).",
      },
      {
        q: "Kiedy ci\u0105g geometryczny jest rosn\u0105cy?",
        a: "Zale\u017Cy to od znaku i warto\u015Bci $q$ oraz $a_1$; najprostszy przypadek: dla dodatnich wyraz\u00F3w ro\u015Bnie, gdy $q>1$.",
      },
      {
        q: "Jaki b\u0142\u0105d najcz\u0119\u015Bciej si\u0119 pojawia?",
        a: "Najcz\u0119\u015Bciej myli si\u0119 ci\u0105g geometryczny z arytmetycznym i dodaje zamiast mno\u017Cy\u0107.",
      },
    ],
  },
  {
    slug: "trygonometria-kata-ostrego",
    lessonId: "5_1_1",
    title: "Trygonometria k\u0105ta ostrego",
    useRealTheory: true,
    faq: [
      {
        q: "Jakie s\u0105 definicje sinusa, cosinusa i tangensa w tr\u00F3jk\u0105cie prostok\u0105tnym?",
        a: "$\\sin\\alpha=\\frac{przeciwleg\u0142a}{przeciwprostok\u0105tna}$, $\\cos\\alpha=\\frac{przyleg\u0142a}{przeciwprostok\u0105tna}$, $\\tan\\alpha=\\frac{przeciwleg\u0142a}{przyleg\u0142a}$.",
      },
      {
        q: "Jak zapami\u0119ta\u0107 zale\u017Cno\u015Bci trygonometryczne?",
        a: "Najwygodniej korzysta\u0107 z rysunku tr\u00F3jk\u0105ta i zawsze odnosi\u0107 boki do wybranego k\u0105ta.",
      },
      {
        q: "Jak obliczy\u0107 bok tr\u00F3jk\u0105ta z sinusa lub cosinusa?",
        a: "Podstawiamy dane do odpowiedniej definicji i przekszta\u0142camy r\u00F3wnanie do szukanego boku.",
      },
      {
        q: "Jak obliczy\u0107 k\u0105t ostry z podanego tangensa?",
        a: "Korzystamy z funkcji odwrotnej, czyli $\\alpha=\\arctan(\\text{warto\u015B\u0107})$.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej?",
        a: "Najcz\u0119\u015Bciej myli si\u0119 bok przyleg\u0142y i przeciwleg\u0142y wzgl\u0119dem rozpatrywanego k\u0105ta.",
      },
    ],
  },
  {
    slug: "twierdzenie-sinusow",
    lessonId: "6_1_8",
    title: "Twierdzenie sinus\u00F3w",
    useRealTheory: true,
    faq: [
      {
        q: "Na czym polega twierdzenie sinus\u00F3w?",
        a: "W dowolnym tr\u00F3jk\u0105cie zachodzi $\\frac{a}{\\sin\\alpha}=\\frac{b}{\\sin\\beta}=\\frac{c}{\\sin\\gamma}$.",
      },
      {
        q: "Kiedy stosowa\u0107 twierdzenie sinus\u00F3w?",
        a: "Gdy znamy par\u0119 bok-k\u0105t naprzeciwko i chcemy wyznaczy\u0107 kolejny bok lub k\u0105t.",
      },
      {
        q: "Czy twierdzenie sinus\u00F3w dzia\u0142a tylko w tr\u00F3jk\u0105cie ostrok\u0105tnym?",
        a: "Nie, dzia\u0142a w ka\u017Cdym tr\u00F3jk\u0105cie.",
      },
      {
        q: "Jak wyznaczy\u0107 brakuj\u0105cy bok z twierdzenia sinus\u00F3w?",
        a: "Tworzymy proporcj\u0119 z odpowiednimi bokami i sinusami k\u0105t\u00F3w, a potem rozwi\u0105zujemy r\u00F3wnanie.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej?",
        a: "Najcz\u0119\u015Bciej łączy si\u0119 bok z nieodpowiednim (nienaprzeciwleg\u0142ym) k\u0105tem.",
      },
    ],
  },
  {
    slug: "twierdzenie-cosinusow",
    lessonId: "6_1_9",
    title: "Twierdzenie cosinus\u00F3w",
    useRealTheory: true,
    faq: [
      {
        q: "Jaki jest wz\u00F3r twierdzenia cosinus\u00F3w?",
        a: "Np. dla boku $c$: $c^2=a^2+b^2-2ab\\cos\\gamma$.",
      },
      {
        q: "Kiedy stosuje si\u0119 twierdzenie cosinus\u00F3w?",
        a: "Gdy znamy dwa boki i k\u0105t mi\u0119dzy nimi albo trzy boki i chcemy policzy\u0107 k\u0105t.",
      },
      {
        q: "Jak obliczy\u0107 k\u0105t z twierdzenia cosinus\u00F3w?",
        a: "Najpierw wyznaczamy warto\u015B\u0107 cosinusa z przekszta\u0142conego wzoru, a potem stosujemy funkcj\u0119 odwrotn\u0105 $\\arccos$.",
      },
      {
        q: "Czym r\u00F3\u017Cni si\u0119 twierdzenie cosinus\u00F3w od Pitagorasa?",
        a: "Twierdzenie Pitagorasa jest szczeg\u00F3lnym przypadkiem twierdzenia cosinus\u00F3w dla k\u0105ta $90^\\circ$.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej?",
        a: "Najcz\u0119\u015Bciej gubi si\u0119 minus przed sk\u0142adnikiem $2ab\\cos\\gamma$ albo podstawia z\u0142y k\u0105t.",
      },
    ],
  },
  {
    slug: "wspolrzedne-punktow",
    lessonId: "7_1_1",
    title: "Wsp\u00F3\u0142rz\u0119dne punkt\u00F3w",
    useRealTheory: true,
    faq: [
      {
        q: "Jak odczyta\u0107 wsp\u00F3\u0142rz\u0119dne punktu na uk\u0142adzie osi?",
        a: "Najpierw odczytujemy warto\u015B\u0107 na osi $OX$ (x), a potem na osi $OY$ (y).",
      },
      {
        q: "Co oznacza punkt $(0,0)$?",
        a: "To pocz\u0105tek uk\u0142adu wsp\u00F3\u0142rz\u0119dnych.",
      },
      {
        q: "Jak rozpozna\u0107 \u0107wiartk\u0119 uk\u0142adu wsp\u00F3\u0142rz\u0119dnych?",
        a: "Patrzymy na znaki wsp\u00F3\u0142rz\u0119dnych: np. w I \u0107wiartce $x>0$ i $y>0$.",
      },
      {
        q: "Jak zaznaczy\u0107 punkt o danych wsp\u00F3\u0142rz\u0119dnych?",
        a: "Idziemy najpierw w osi $x$, potem r\u00F3wnolegle do osi $y$ i zaznaczamy przeci\u0119cie.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej?",
        a: "Najcz\u0119\u015Bciej zamienia si\u0119 kolejno\u015B\u0107 wsp\u00F3\u0142rz\u0119dnych i myli zapis $(x,y)$ z $(y,x)$.",
      },
    ],
  },
  {
    slug: "odleglosc-punktow",
    lessonId: "7_1_2",
    title: "Odleg\u0142o\u015B\u0107 punkt\u00F3w",
    useRealTheory: true,
    faq: [
      {
        q: "Jak obliczy\u0107 odleg\u0142o\u015B\u0107 dw\u00F3ch punkt\u00F3w na p\u0142aszczy\u017Anie?",
        a: "Stosujemy wz\u00F3r $d=\\sqrt{(x_2-x_1)^2+(y_2-y_1)^2}$.",
      },
      {
        q: "Jak policzy\u0107 odleg\u0142o\u015B\u0107 punkt\u00F3w na osi liczbowej?",
        a: "To warto\u015B\u0107 bezwzgl\u0119dna r\u00F3\u017Cnicy wsp\u00F3\u0142rz\u0119dnych: $|x_2-x_1|$.",
      },
      {
        q: "Sk\u0105d bierze si\u0119 wz\u00F3r na odleg\u0142o\u015B\u0107 punkt\u00F3w?",
        a: "Wynika z twierdzenia Pitagorasa dla tr\u00F3jk\u0105ta prostok\u0105tnego utworzonego przez r\u00F3\u017Cnice wsp\u00F3\u0142rz\u0119dnych.",
      },
      {
        q: "Czy kolejno\u015B\u0107 punkt\u00F3w ma znaczenie?",
        a: "Nie, odleg\u0142o\u015B\u0107 jest taka sama niezale\u017Cnie od kolejno\u015Bci podstawienia punkt\u00F3w.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej?",
        a: "Najcz\u0119\u015Bciej zapomina si\u0119 o podniesieniu r\u00F3\u017Cnic do kwadratu albo o pierwiastku na ko\u0144cu.",
      },
    ],
  },
  {
    slug: "dlugosc-odcinka",
    lessonId: "7_1_2",
    title: "D\u0142ugo\u015B\u0107 odcinka",
    useRealTheory: true,
    faq: [
      {
        q: "Jak obliczy\u0107 d\u0142ugo\u015B\u0107 odcinka mi\u0119dzy punktami A i B?",
        a: "Stosujemy wz\u00F3r na odleg\u0142o\u015B\u0107 punkt\u00F3w: $|AB|=\\sqrt{(x_2-x_1)^2+(y_2-y_1)^2}$.",
      },
      {
        q: "Czy d\u0142ugo\u015B\u0107 odcinka i odleg\u0142o\u015B\u0107 punkt\u00F3w to to samo?",
        a: "Tak. W geometrii analitycznej d\u0142ugo\u015B\u0107 odcinka $AB$ jest odleg\u0142o\u015Bci\u0105 mi\u0119dzy punktami $A$ i $B$.",
      },
      {
        q: "Jak policzy\u0107 d\u0142ugo\u015B\u0107 odcinka na osi liczbowej?",
        a: "To warto\u015B\u0107 bezwzgl\u0119dna r\u00F3\u017Cnicy wsp\u00F3\u0142rz\u0119dnych: $|x_2-x_1|$.",
      },
      {
        q: "Sk\u0105d bierze si\u0119 wz\u00F3r na d\u0142ugo\u015B\u0107 odcinka?",
        a: "Wynika z twierdzenia Pitagorasa dla tr\u00F3jk\u0105ta prostok\u0105tnego zbudowanego na r\u00F3\u017Cnicach wsp\u00F3\u0142rz\u0119dnych.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej przy d\u0142ugo\u015Bci odcinka?",
        a: "Najcz\u0119\u015Bciej pomija si\u0119 pierwiastek lub nie podnosi r\u00F3\u017Cnic wsp\u00F3\u0142rz\u0119dnych do kwadratu.",
      },
    ],
  },
  {
    slug: "srodek-odcinka",
    lessonId: "7_1_3",
    title: "\u015Arodek odcinka",
    useRealTheory: true,
    faq: [
      {
        q: "Jak obliczy\u0107 wsp\u00F3\u0142rz\u0119dne \u015Brodka odcinka?",
        a: "Dla punkt\u00F3w $A(x_1,y_1)$ i $B(x_2,y_2)$ mamy $S\\left(\\frac{x_1+x_2}{2},\\frac{y_1+y_2}{2}\\right)$.",
      },
      {
        q: "Dlaczego we wzorze na \u015Brodek odcinka dzielimy przez 2?",
        a: "Bo \u015Brodek odcinka jest \u015Bredni\u0105 arytmetyczn\u0105 odpowiednich wsp\u00F3\u0142rz\u0119dnych ko\u0144c\u00F3w.",
      },
      {
        q: "Czy kolejno\u015B\u0107 punkt\u00F3w ma znaczenie przy \u015Brodku odcinka?",
        a: "Nie, wynik b\u0119dzie ten sam dla zamienionych punkt\u00F3w.",
      },
      {
        q: "Jak znale\u017A\u0107 brakuj\u0105cy koniec odcinka, gdy znamy \u015Brodek?",
        a: "Przekszta\u0142camy wzory na \u015Brodek osobno dla wsp\u00F3\u0142rz\u0119dnej $x$ i $y$.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej?",
        a: "Najcz\u0119\u015Bciej dzieli si\u0119 tylko jedn\u0105 wsp\u00F3\u0142rz\u0119dn\u0105 przez 2 zamiast obie.",
      },
    ],
  },
  {
    slug: "postac-kierunkowa-prostej",
    lessonId: "7_2_1",
    title: "Posta\u0107 kierunkowa prostej",
    useRealTheory: true,
    faq: [
      {
        q: "Co to jest posta\u0107 kierunkowa prostej?",
        a: "To zapis $y=ax+b$, gdzie $a$ to wsp\u00F3\u0142czynnik kierunkowy, a $b$ to wyraz wolny.",
      },
      {
        q: "Jak odczyta\u0107 wsp\u00F3\u0142czynnik kierunkowy prostej?",
        a: "Wsp\u00F3\u0142czynnik kierunkowy to liczba stoj\u0105ca przy $x$, czyli $a$.",
      },
      {
        q: "Jak wyznaczy\u0107 r\u00F3wnanie prostej przez dwa punkty?",
        a: "Najpierw liczymy $a=\\frac{y_2-y_1}{x_2-x_1}$, potem podstawiamy punkt do wzoru $y=ax+b$ i wyznaczamy $b$.",
      },
      {
        q: "Kiedy proste s\u0105 r\u00F3wnoleg\u0142e lub prostopad\u0142e?",
        a: "R\u00F3wnoleg\u0142e maj\u0105 ten sam wsp\u00F3\u0142czynnik kierunkowy, a prostopad\u0142e spe\u0142niaj\u0105 zale\u017Cno\u015B\u0107 $a_1\\cdot a_2=-1$.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej?",
        a: "Najcz\u0119\u015Bciej myli si\u0119 wsp\u00F3\u0142czynnik kierunkowy z wyrazem wolnym albo b\u0142\u0119dnie liczy r\u00F3\u017Cnice wsp\u00F3\u0142rz\u0119dnych.",
      },
    ],
  },
  {
    slug: "rownanie-okregu",
    lessonId: "7_3_1",
    title: "R\u00F3wnanie okr\u0119gu",
    useRealTheory: true,
    faq: [
      {
        q: "Jaka jest posta\u0107 kanoniczna r\u00F3wnania okr\u0119gu?",
        a: "To $(x-a)^2+(y-b)^2=r^2$, gdzie $(a,b)$ jest \u015Brodkiem, a $r$ promieniem.",
      },
      {
        q: "Jak odczyta\u0107 \u015Brodek i promie\u0144 z r\u00F3wnania okr\u0119gu?",
        a: "Ze wzoru kanonicznego odczytujemy \u015Brodek $(a,b)$ i promie\u0144 $r=\\sqrt{r^2}$.",
      },
      {
        q: "Jak zapisa\u0107 r\u00F3wnanie okr\u0119gu o \u015Brodku w punkcie $S$ i promieniu $r$?",
        a: "Podstawiamy wsp\u00F3\u0142rz\u0119dne \u015Brodka do wzoru $(x-a)^2+(y-b)^2=r^2$.",
      },
      {
        q: "Kiedy punkt nale\u017Cy do okr\u0119gu?",
        a: "Gdy po podstawieniu jego wsp\u00F3\u0142rz\u0119dnych do r\u00F3wnania otrzymujemy prawdziw\u0105 r\u00F3wno\u015B\u0107.",
      },
      {
        q: "Jaki b\u0142\u0105d pojawia si\u0119 najcz\u0119\u015Bciej przy r\u00F3wnaniu okr\u0119gu?",
        a: "Najcz\u0119\u015Bciej gubi si\u0119 znak przy \u015Brodku, np. myli $(x-2)^2$ z \u015Brodkiem $(-2,\\cdot)$ zamiast $(2,\\cdot)$.",
      },
    ],
  },
  {
    slug: "elementy-okregu-i-kola",
    lessonId: "6_3_1",
    title: "Elementy koła i okręgu",
    useRealTheory: true,
    faq: [
      { q: "Jakie są podstawowe elementy okręgu?", a: "Najczęściej używamy: promienia, średnicy, cięciwy, łuku i stycznej." },
      { q: "Czym różni się okrąg od koła?", a: "Okrąg to linia brzegowa, a koło to obszar ograniczony okręgiem." },
      { q: "Ile wynosi zależność między promieniem i średnicą?", a: "Średnica jest dwa razy większa od promienia: $d=2r$." },
      { q: "Co to jest cięciwa okręgu?", a: "To odcinek łączący dwa punkty leżące na okręgu." },
      { q: "Co warto zapamiętać na start?", a: "Najważniejsze relacje to $d=2r$, wzór na obwód i wzór na pole koła." },
    ],
  },
  {
    slug: "katy-w-okregu",
    lessonId: "6_3_2",
    title: "Kąty w okręgu",
    useRealTheory: true,
    faq: [
      { q: "Czym jest kąt środkowy?", a: "To kąt, którego wierzchołek leży w środku okręgu." },
      { q: "Czym jest kąt wpisany?", a: "To kąt, którego wierzchołek leży na okręgu, a ramiona przecinają okrąg." },
      { q: "Jaka jest zależność kąta wpisanego i środkowego?", a: "Kąt wpisany oparty na tym samym łuku ma miarę równą połowie kąta środkowego." },
      { q: "Kiedy kąty wpisane są równe?", a: "Gdy są oparte na tym samym łuku." },
      { q: "Najczęstszy błąd w zadaniach z kątami w okręgu?", a: "Mylenie łuku, na którym oparty jest kąt, i błędne podwojenie/połowienie miary." },
    ],
  },
  {
    slug: "odcinki-stycznych-i-siecznych",
    lessonId: "6_3_3",
    title: "Odcinki stycznych i siecznych",
    useRealTheory: true,
    faq: [
      { q: "Jak korzystać z twierdzenia o stycznej i siecznej?", a: "Stosujemy zależność iloczynową między odcinkami wychodzącymi z jednego punktu zewnętrznego." },
      { q: "Co jest kluczowe przy oznaczeniach?", a: "Dokładne zaznaczenie punktu zewnętrznego i podziału odcinków na część zewnętrzną i całą." },
      { q: "Czy styczna jest prostopadła do promienia?", a: "Tak, promień poprowadzony do punktu styczności jest prostopadły do stycznej." },
      { q: "Po co ta lekcja na maturze?", a: "To częsty typ zadania w planimetrii: szybkie równanie z geometrii i proporcji." },
      { q: "Jaki jest najczęstszy błąd przy odcinkach stycznych i siecznych?", a: "Podstawienie złych długości do wzoru, zwłaszcza mylenie odcinka całego z jego częścią." },
    ],
  },
  {
    slug: "kwadrat-pole-i-obwod",
    lessonId: "6_2_1",
    title: "Kwadrat – pole i obwód",
    useRealTheory: true,
    faq: [
      { q: "Jaki jest wzór na pole kwadratu?", a: "Pole kwadratu o boku $a$ to $P=a^2$." },
      { q: "Jaki jest wzór na obwód kwadratu?", a: "Obwód kwadratu o boku $a$ to $O=4a$." },
      { q: "Jak policzyć bok z pola?", a: "Jeśli $P=a^2$, to $a=\\sqrt{P}$." },
      { q: "Co z przekątną kwadratu?", a: "Przekątna ma długość $d=a\\sqrt{2}$." },
      { q: "Jaki jest najczęstszy błąd przy zadaniach o polu i obwodzie kwadratu?", a: "Mylenie wzorów na pole i obwód oraz brak jednostek w odpowiedzi." },
    ],
  },
  {
    slug: "prostokat-pole-i-obwod",
    lessonId: "6_2_1",
    title: "Prostokąt – pole i obwód",
    useRealTheory: true,
    faq: [
      { q: "Jaki jest wzór na pole prostokąta?", a: "Dla boków $a$ i $b$: $P=ab$." },
      { q: "Jaki jest wzór na obwód prostokąta?", a: "Dla boków $a$ i $b$: $O=2a+2b$." },
      { q: "Jak wyznaczyć bok, znając pole i drugi bok?", a: "Dzielimy pole przez znany bok: $a=\\frac{P}{b}$." },
      { q: "Jak liczyć przekątną prostokąta?", a: "Ze wzoru Pitagorasa: $d=\\sqrt{a^2+b^2}$." },
      { q: "Jaki jest najczęstszy błąd przy zadaniach o polu i obwodzie prostokąta?", a: "Dodawanie boków przy polu zamiast ich mnożenia." },
    ],
  },
  {
    slug: "rownoleglobok-pole-i-obwod",
    lessonId: "6_2_2",
    title: "Równoległobok – pole i obwód",
    useRealTheory: true,
    faq: [
      { q: "Jaki jest wzór na pole równoległoboku?", a: "Pole to iloczyn boku i wysokości: $P=a\\cdot h_a$." },
      { q: "Jaki jest wzór na obwód równoległoboku?", a: "Dla boków $a$ i $b$: $O=2a+2b$." },
      { q: "Czy wysokość musi być bokiem figury?", a: "Nie, wysokość jest odcinkiem prostopadłym do podstawy." },
      { q: "Jakie dane są najczęściej potrzebne?", a: "Podstawa i wysokość do tej podstawy albo dane do ich wyznaczenia." },
      { q: "Jaki jest najczęstszy błąd przy obliczaniu pola równoległoboku?", a: "Podstawienie do wzoru nie tej wysokości, która odpowiada wybranemu bokowi." },
    ],
  },
  {
    slug: "romb-pole-i-obwod",
    lessonId: "6_2_2",
    title: "Romb – pole i obwód",
    useRealTheory: true,
    faq: [
      { q: "Jaki jest wzór na pole rombu?", a: "Najczęściej: $P=a\\cdot h$ lub $P=\\frac{e\\cdot f}{2}$ dla przekątnych $e,f$." },
      { q: "Jaki jest wzór na obwód rombu?", a: "Jeśli bok ma długość $a$, to $O=4a$." },
      { q: "Co jest charakterystyczne dla rombu?", a: "Wszystkie boki są równe, a przekątne przecinają się pod kątem prostym." },
      { q: "Kiedy używać wzoru z przekątnymi?", a: "Gdy w zadaniu podane są długości przekątnych." },
      { q: "Jaki jest najczęstszy błąd przy zadaniach o rombie?", a: "Mylenie rombu z kwadratem i automatyczne zakładanie kąta prostego." },
    ],
  },
  {
    slug: "trapez-pole-i-obwod",
    lessonId: "6_2_3",
    title: "Trapez – pole i obwód",
    useRealTheory: true,
    faq: [
      { q: "Jaki jest wzór na pole trapezu?", a: "Dla podstaw $a,b$ i wysokości $h$: $P=\\frac{(a+b)\\cdot h}{2}$." },
      { q: "Jak liczyć obwód trapezu?", a: "Dodajemy wszystkie boki: $O=a+b+c+d$." },
      { q: "Co to są podstawy trapezu?", a: "To para boków równoległych." },
      { q: "Jak wyznaczyć wysokość trapezu?", a: "Najczęściej z twierdzenia Pitagorasa lub z przekształconego wzoru na pole." },
      { q: "Jaki jest najczęstszy błąd przy obliczaniu pola trapezu?", a: "Brak dzielenia przez 2 we wzorze na pole." },
    ],
  },
  {
    slug: "pole-kola",
    lessonId: "6_3_1",
    title: "Pole koła",
    useRealTheory: true,
    faq: [
      { q: "Jaki jest wzór na pole koła?", a: "Pole koła o promieniu $r$ to $P=\\pi r^2$." },
      { q: "Jak policzyć pole koła ze średnicy?", a: "Najpierw liczysz promień $r=\\frac{d}{2}$, potem podstawiasz do $P=\\pi r^2$." },
      { q: "Kiedy używać przybliżenia liczby $\\pi$?", a: "Gdy polecenie wymaga wyniku przybliżonego, np. dla $\\pi\\approx 3{,}14$." },
      { q: "Jakie jednostki ma pole koła?", a: "Zawsze jednostki kwadratowe, np. $cm^2$, $m^2$." },
      { q: "Jaki jest najczęstszy błąd przy obliczaniu pola koła?", a: "Podstawienie średnicy zamiast promienia bez podzielenia przez 2." },
    ],
  },
  {
    slug: "obwod-kola",
    lessonId: "6_3_1",
    title: "Obwód koła",
    useRealTheory: true,
    faq: [
      { q: "Jaki jest wzór na obwód koła?", a: "Obwód koła to $L=2\\pi r$ lub równoważnie $L=\\pi d$." },
      { q: "Kiedy użyć wzoru z promieniem, a kiedy ze średnicą?", a: "Użyj tego, do którego masz dane w zadaniu." },
      { q: "Czy obwód i pole mają te same jednostki?", a: "Nie. Obwód ma jednostki długości, a pole ma jednostki kwadratowe." },
      { q: "Jak policzyć promień z obwodu?", a: "Przekształcamy wzór: $r=\\frac{L}{2\\pi}$." },
      { q: "Jaki jest najczęstszy błąd przy obliczaniu obwodu koła?", a: "Mylenie wzoru na obwód z wzorem na pole." },
    ],
  },
  {
    slug: "dlugosc-okregu",
    lessonId: "6_3_1",
    title: "Długość okręgu",
    useRealTheory: true,
    faq: [
      { q: "Jak obliczyć długość okręgu?", a: "Długość okręgu liczymy ze wzoru $L=2\\pi r$ albo $L=\\pi d$." },
      { q: "Czy długość okręgu i obwód koła to to samo?", a: "Tak, to dwa równoważne określenia tej samej wielkości." },
      { q: "Jak policzyć długość okręgu ze średnicy?", a: "Wstawiamy średnicę do wzoru $L=\\pi d$." },
      { q: "Jak policzyć promień, gdy znam długość okręgu?", a: "Przekształcamy wzór: $r=\\frac{L}{2\\pi}$." },
      { q: "Jaki jest najczęstszy błąd przy zadaniach o długości okręgu?", a: "Mylenie średnicy z promieniem i podstawianie nie tej wartości do wzoru." },
    ],
  },
  {
    slug: "uklady-rownan-liniowych",
    lessonId: "2_4_1",
    title: "Układy równań liniowych",
    useRealTheory: true,
    faq: [
      { q: "Jak rozwiązać układ równań liniowych?", a: "Najczęściej stosujemy metodę podstawiania albo przeciwnych współczynników." },
      { q: "Kiedy układ ma jedno rozwiązanie?", a: "Gdy proste przecinają się w jednym punkcie." },
      { q: "Kiedy układ nie ma rozwiązań?", a: "Gdy proste są równoległe i różne." },
      { q: "Kiedy układ ma nieskończenie wiele rozwiązań?", a: "Gdy równania opisują tę samą prostą." },
      { q: "Jaki jest najczęstszy błąd przy rozwiązywaniu układów równań liniowych?", a: "Błędne przenoszenie wyrazów i znaki minus przy redukcji równań." },
    ],
  },
  {
    slug: "wykres-funkcji",
    lessonId: "3_1_2",
    title: "Wykres funkcji",
    useRealTheory: true,
    faq: [
      { q: "Jak narysować wykres funkcji krok po kroku?", a: "Wyznacz kilka punktów dla wybranych argumentów i zaznacz je w układzie współrzędnych." },
      { q: "Co to jest dziedzina funkcji?", a: "To zbiór argumentów, dla których funkcja jest określona (istnieje)." },
      { q: "Co to jest zbiór wartości funkcji?", a: "To zbiór wszystkich wartości, które funkcja przyjmuje." },
      { q: "Jak odczytać miejsca zerowe z wykresu?", a: "To punkty przecięcia wykresu z osią $OX$." },
      { q: "Jaki jest najczęstszy błąd przy odczytywaniu wykresu funkcji?", a: "Mylenie argumentu $x$ z wartością funkcji $y$ przy odczycie punktów." },
    ],
  },
  {
    slug: "przesuniecia-wykresu-funkcji",
    lessonId: "3_8_2",
    title: "Przesunięcia wykresu funkcji",
    useRealTheory: true,
    faq: [
      { q: "Jak przesunąć wykres funkcji o wektor?", a: "W zapisie wzoru modyfikujemy argument i/lub wartość funkcji zgodnie z kierunkiem przesunięcia." },
      { q: "Co robi zapis $f(x-a)$?", a: "Przesuwa wykres w prawo o $a$." },
      { q: "Co robi zapis $f(x)+b$?", a: "Przesuwa wykres w górę o $b$." },
      { q: "Jak przesunięcie wpływa na miejsca zerowe?", a: "Mogą się przesunąć, bo zmienia się położenie całego wykresu." },
      { q: "Jaki jest najczęstszy błąd przy przesunięciach wykresu funkcji?", a: "Mylenie kierunku dla zapisu wewnątrz nawiasu, np. $x-a$ vs $x+a$." },
    ],
  },
  {
    slug: "symetrie-wykresu-funkcji",
    lessonId: "3_8_3",
    title: "Symetrie wykresu funkcji",
    useRealTheory: true,
    faq: [
      { q: "Jak wygląda odbicie wykresu względem osi $OX$?", a: "Zmieniamy $f(x)$ na $-f(x)$." },
      { q: "Jak wygląda odbicie względem osi $OY$?", a: "Zmieniamy $f(x)$ na $f(-x)$." },
      { q: "Jak rozpoznać funkcję parzystą?", a: "Spełnia warunek $f(-x)=f(x)$ i jest symetryczna względem osi $OY$." },
      { q: "Jak rozpoznać funkcję nieparzystą?", a: "Spełnia warunek $f(-x)=-f(x)$ i jest symetryczna względem początku układu." },
      { q: "Jaki jest najczęstszy błąd przy symetriach wykresu funkcji?", a: "Mylenie odbicia względem osi z odbiciem względem początku układu." },
    ],
  },
  {
    slug: "zasada-mnozenia-i-dodawania",
    lessonId: "9_1_1",
    title: "Zasada mnożenia i dodawania",
    useRealTheory: true,
    faq: [
      { q: "Kiedy stosować zasadę dodawania?", a: "Gdy liczymy liczbę możliwości dla rozłącznych przypadków typu „albo–albo”." },
      { q: "Kiedy stosować zasadę mnożenia?", a: "Gdy wykonujemy kolejne etapy typu „i potem”, czyli łączymy wybory." },
      { q: "Jak rozpoznać właściwą zasadę w zadaniu?", a: "Sprawdź, czy przypadki się wykluczają (dodawanie) czy tworzą sekwencję działań (mnożenie)." },
      { q: "Czy można łączyć obie zasady?", a: "Tak, w wielu zadaniach najpierw mnożymy w etapach, a potem dodajemy przypadki." },
      { q: "Jaki jest najczęstszy błąd przy zasadzie mnożenia i dodawania?", a: "Zastosowanie dodawania tam, gdzie trzeba pomnożyć liczbę wyborów z kolejnych kroków." },
    ],
  },
  {
    slug: "permutacje",
    lessonId: "9_1_2",
    title: "Permutacje",
    useRealTheory: true,
    faq: [
      { q: "Co to jest permutacja?", a: "To uporządkowanie wszystkich elementów danego zbioru." },
      { q: "Jaki jest wzór na liczbę permutacji $n$ elementów?", a: "Liczba permutacji to $n!$." },
      { q: "Co oznacza silnia?", a: "To iloczyn kolejnych liczb naturalnych: $n!=1\\cdot 2\\cdot ... \\cdot n$." },
      { q: "Czy permutacje uwzględniają kolejność?", a: "Tak, kolejność elementów ma kluczowe znaczenie." },
      { q: "Jaki jest najczęstszy błąd przy zadaniach z permutacji?", a: "Mylenie permutacji z kombinacjami, gdzie kolejność nie ma znaczenia." },
    ],
  },
  {
    slug: "wariacje",
    lessonId: "9_1_3",
    title: "Wariacje",
    useRealTheory: true,
    faq: [
      { q: "Co to są wariacje bez powtórzeń?", a: "To uporządkowane wybory $k$ elementów z $n$, bez ponownego użycia elementu." },
      { q: "Jaki jest wzór na wariacje bez powtórzeń?", a: "Najczęściej: $V_n^k=\\frac{n!}{(n-k)!}$." },
      { q: "Czy w wariacjach kolejność ma znaczenie?", a: "Tak, dlatego wariacje różnią się od kombinacji." },
      { q: "Kiedy używać wariacji?", a: "Gdy wybieramy kilka elementów i ich kolejność jest istotna." },
      { q: "Jaki jest najczęstszy błąd przy zadaniach z wariacji?", a: "Stosowanie wzoru na kombinacje, mimo że kolejność w zadaniu jest ważna." },
    ],
  },
  {
    slug: "kombinacje",
    lessonId: "9_1_4",
    title: "Kombinacje",
    useRealTheory: true,
    faq: [
      { q: "Co to są kombinacje?", a: "To wybory $k$ elementów z $n$, w których kolejność nie ma znaczenia." },
      { q: "Jaki jest wzór na kombinacje?", a: "Korzystamy z: $\\binom{n}{k}=\\frac{n!}{k!(n-k)!}$." },
      { q: "Kiedy stosować kombinacje?", a: "Gdy liczymy, ile można utworzyć grup/zbiorów bez ustawiania kolejności." },
      { q: "Czy kombinacje i wariacje to to samo?", a: "Nie. W wariacjach kolejność ma znaczenie, w kombinacjach nie." },
      { q: "Jaki jest najczęstszy błąd przy zadaniach z kombinacji?", a: "Liczenie tych samych grup wielokrotnie przez niepotrzebne rozróżnianie kolejności." },
    ],
  },
  {
    slug: "rachunek-prawdopodobienstwa",
    lessonId: "9_2_1",
    title: "Podstawy rachunku prawdopodobieństwa",
    useRealTheory: true,
    faq: [
      { q: "Jaki jest klasyczny wzór na prawdopodobieństwo?", a: "Dla wyników jednakowo prawdopodobnych: $P(A)=\\frac{|A|}{|\\Omega|}$." },
      { q: "Co to jest przestrzeń zdarzeń elementarnych?", a: "To zbiór wszystkich możliwych wyników doświadczenia losowego." },
      { q: "Jakie wartości może przyjmować prawdopodobieństwo?", a: "Zawsze od 0 do 1." },
      { q: "Co to jest zdarzenie przeciwne?", a: "To zdarzenie, które zachodzi wtedy i tylko wtedy, gdy zdarzenie $A$ nie zachodzi." },
      { q: "Jaki jest najczęstszy błąd w rachunku prawdopodobieństwa klasycznego?", a: "Błędne policzenie liczby wszystkich możliwych wyników." },
    ],
  },
  {
    slug: "srednia-arytmetyczna",
    lessonId: "9_3_1",
    title: "Średnia arytmetyczna",
    useRealTheory: true,
    faq: [
      { q: "Jak obliczyć średnią arytmetyczną?", a: "Dodajemy wszystkie wartości i dzielimy przez ich liczbę." },
      { q: "Jaki jest wzór na średnią arytmetyczną?", a: "$\\bar{x}=\\frac{x_1+x_2+...+x_n}{n}$." },
      { q: "Czy średnia może nie wystarczyć do opisu danych?", a: "Tak, dlatego często analizuje się też medianę i rozrzut wyników." },
      { q: "Jak policzyć brakującą wartość, gdy znamy średnią?", a: "Tworzymy równanie ze wzoru na średnią i wyznaczamy niewiadomą." },
      { q: "Jaki jest najczęstszy błąd przy obliczaniu średniej arytmetycznej?", a: "Dzielenie przez złą liczbę danych po zsumowaniu wartości." },
    ],
  },
  {
    slug: "upraszczanie-wyrazen-algebraicznych",
    lessonId: "2_1_1",
    title: "Upraszczanie wyrażeń algebraicznych",
    useRealTheory: true,
    faq: [
      { q: "Na czym polega upraszczanie wyrażeń algebraicznych?", a: "To wykonywanie działań i redukcja wyrazów podobnych, aby otrzymać prostszą równoważną postać." },
      { q: "Co to są wyrazy podobne?", a: "To wyrazy mające tę samą część literową, np. $3x$ i $-7x$." },
      { q: "W jakiej kolejności upraszczać wyrażenie algebraiczne?", a: "Najpierw usuwamy nawiasy i wykonujemy działania, potem łączymy wyrazy podobne." },
      { q: "Czy kolejność składników ma znaczenie?", a: "Nie, ale warto porządkować wyrażenie malejąco względem potęg zmiennej." },
      { q: "Jaki jest najczęstszy błąd przy upraszczaniu wyrażeń algebraicznych?", a: "Błędne usuwanie nawiasu z minusem i zmiana tylko części znaków." },
    ],
  },
  {
    slug: "ulamki-algebraiczne",
    lessonId: "2_1_3",
    title: "Ułamki algebraiczne",
    useRealTheory: true,
    faq: [
      { q: "Co to jest ułamek algebraiczny?", a: "To ułamek, w którym w liczniku lub mianowniku występują wyrażenia algebraiczne." },
      { q: "Jak skracać ułamki algebraiczne?", a: "Rozkładamy licznik i mianownik na czynniki, a następnie skracamy wspólne czynniki." },
      { q: "Kiedy ułamek algebraiczny jest określony?", a: "Gdy mianownik nie jest równy zero." },
      { q: "Jak dodawać ułamki algebraiczne?", a: "Sprowadzamy je do wspólnego mianownika, dodajemy liczniki i upraszczamy wynik." },
      { q: "Jaki jest najczęstszy błąd przy ułamkach algebraicznych?", a: "Skracanie składników po dodawaniu zamiast skracania czynników." },
    ],
  },
  {
    slug: "rownania-wymierne",
    lessonId: "2_2_3",
    title: "Równania wymierne",
    useRealTheory: true,
    faq: [
      { q: "Co to jest równanie wymierne?", a: "To równanie, w którym niewiadoma występuje w mianowniku wyrażenia wymiernego." },
      { q: "Od czego zacząć rozwiązywanie równania wymiernego?", a: "Najpierw wyznaczamy dziedzinę, czyli warunki że mianowniki są różne od zera." },
      { q: "Jak usuwać mianowniki w równaniu wymiernym?", a: "Mnożymy obie strony równania przez wspólną wielokrotność mianowników." },
      { q: "Czy każde otrzymane rozwiązanie jest poprawne?", a: "Nie, na końcu trzeba sprawdzić, czy nie łamie warunków dziedziny." },
      { q: "Jaki jest najczęstszy błąd przy równaniach wymiernych?", a: "Pomijanie dziedziny i przyjmowanie rozwiązań, które zerują mianownik." },
    ],
  },
  {
    slug: "rownania-z-wartoscia-bezwzgledna",
    lessonId: "2_2_4",
    title: "Równania z wartością bezwzględną",
    useRealTheory: true,
    faq: [
      { q: "Jak rozwiązywać równanie z wartością bezwzględną?", a: "Najczęściej rozbijamy je na przypadki zależne od znaku wyrażenia pod wartością bezwzględną." },
      { q: "Co oznacza zapis $|x-a|=b$?", a: "To równoważne dwóm równaniom: $x-a=b$ lub $x-a=-b$ dla $b\\ge 0$." },
      { q: "Kiedy równanie $|W(x)|=b$ nie ma rozwiązań?", a: "Gdy $b<0$, bo wartość bezwzględna nigdy nie jest ujemna." },
      { q: "Czy trzeba sprawdzać rozwiązania po rozbiciu na przypadki?", a: "Tak, warto podstawić wynik do równania wyjściowego." },
      { q: "Jaki jest najczęstszy błąd przy równaniach z wartością bezwzględną?", a: "Zapisanie tylko jednego przypadku zamiast dwóch." },
    ],
  },
  {
    slug: "nierownosci-z-wartoscia-bezwzgledna",
    lessonId: "2_3_3",
    title: "Nierówności z wartością bezwzględną",
    useRealTheory: true,
    faq: [
      { q: "Jak rozwiązywać nierówności z wartością bezwzględną?", a: "Korzystamy z interpretacji odległości albo rozbijamy nierówność na odpowiednie przypadki." },
      { q: "Co oznacza nierówność $|x-a|<r$?", a: "To liczby odległe od $a$ o mniej niż $r$, czyli przedział $(a-r,a+r)$ dla $r>0$." },
      { q: "Co oznacza nierówność $|x-a|>r$?", a: "To liczby odległe od $a$ o więcej niż $r$, czyli suma przedziałów $(-\\infty,a-r)\\cup(a+r,\\infty)$." },
      { q: "Kiedy nierówność z wartością bezwzględną ma wszystkie liczby jako rozwiązanie?", a: "Np. gdy po przekształceniu otrzymamy warunek zawsze prawdziwy." },
      { q: "Jaki jest najczęstszy błąd przy nierównościach z wartością bezwzględną?", a: "Mylenie przypadków dla znaków $<$ i $>$ oraz błędny zapis przedziałów." },
    ],
  },
  {
    slug: "uklady-rownan-liniowych-i-kwadratowych",
    lessonId: "2_4_3",
    title: "Układy równań liniowych i kwadratowych",
    useRealTheory: true,
    faq: [
      { q: "Jak rozwiązać układ równań liniowych i kwadratowych?", a: "Najczęściej wyznaczamy jedną zmienną z równania liniowego i podstawiamy do równania kwadratowego." },
      { q: "Ile rozwiązań może mieć taki układ?", a: "Najczęściej 0, 1 albo 2 pary rozwiązań w zależności od przecięcia wykresów." },
      { q: "Czy trzeba sprawdzać rozwiązania po podstawieniu?", a: "Tak, każdą parę warto sprawdzić w obu równaniach." },
      { q: "Jak interpretować rozwiązanie geometrycznie?", a: "To punkty wspólne prostej i paraboli." },
      { q: "Jaki jest najczęstszy błąd przy układach liniowych i kwadratowych?", a: "Zgubienie jednego z rozwiązań równania kwadratowego po podstawieniu." },
    ],
  },
  {
    slug: "podzielnosc-liczb-calkowitych",
    lessonId: "1_3_1",
    title: "Podzielność liczb całkowitych",
    useRealTheory: true,
    faq: [
      { q: "Kiedy liczba jest podzielna przez 2, 3, 5 i 9?", a: "Stosujemy cechy podzielności: przez 2 ostatnia cyfra parzysta, przez 3 i 9 suma cyfr podzielna odpowiednio przez 3 lub 9, przez 5 końcówka 0 albo 5." },
      { q: "Co oznacza zapis $a\\mid b$?", a: "Oznacza, że liczba $a$ dzieli liczbę $b$ bez reszty." },
      { q: "Jak sprawdzić podzielność przez 4?", a: "Sprawdzamy, czy liczba utworzona z dwóch ostatnich cyfr jest podzielna przez 4." },
      { q: "Jak sprawdzić podzielność przez 10?", a: "Liczba musi kończyć się cyfrą 0." },
      { q: "Jaki jest najczęstszy błąd przy zadaniach z podzielności?", a: "Mylone są cechy podzielności przez 3 i przez 9." },
    ],
  },
  {
    slug: "liczby-pierwsze",
    lessonId: "1_3_2",
    title: "Liczby pierwsze i złożone",
    useRealTheory: true,
    faq: [
      { q: "Co to jest liczba pierwsza?", a: "To liczba naturalna większa od 1, która ma dokładnie dwa dzielniki: 1 i samą siebie." },
      { q: "Czy liczba 1 jest pierwsza?", a: "Nie, bo ma tylko jeden dzielnik." },
      { q: "Jak sprawdzić, czy liczba jest pierwsza?", a: "Sprawdzamy podzielność przez liczby pierwsze nie większe niż $\\sqrt{n}$." },
      { q: "Co to jest rozkład liczby na czynniki pierwsze?", a: "To zapis liczby jako iloczynu liczb pierwszych." },
      { q: "Jaki jest najczęstszy błąd przy liczbach pierwszych?", a: "Uznawanie liczby 1 za liczbę pierwszą." },
    ],
  },
  {
    slug: "pochodna-funkcji",
    lessonId: "3_7_1",
    title: "Pochodna funkcji",
    useRealTheory: true,
    faq: [
      { q: "Co to jest pochodna funkcji?", a: "To miara szybkości zmian funkcji, czyli nachylenie stycznej do wykresu w danym punkcie." },
      { q: "Jaka jest pochodna funkcji potęgowej $x^n$?", a: "Dla $n\\in\\mathbb{R}$: $(x^n)'=n\\cdot x^{n-1}$." },
      { q: "Po co liczy się pochodną?", a: "Do badania monotoniczności, ekstremów, stycznych i optymalizacji." },
      { q: "Kiedy funkcja rośnie na podstawie pochodnej?", a: "Gdy jej pochodna jest dodatnia na danym przedziale." },
      { q: "Jaki jest najczęstszy błąd przy obliczaniu pochodnej?", a: "Nieuwzględnianie reguł dla iloczynu, ilorazu lub funkcji złożonej." },
    ],
  },
  {
    slug: "styczna-do-wykresu-funkcji",
    lessonId: "3_7_2",
    title: "Styczna do wykresu funkcji",
    useRealTheory: true,
    faq: [
      { q: "Jak wyznaczyć równanie stycznej do wykresu funkcji?", a: "Liczymy pochodną, wyznaczamy współczynnik kierunkowy $m=f'(x_0)$ i stosujemy wzór prostej przez punkt." },
      { q: "Jaki jest wzór na styczną w punkcie $x_0$?", a: "Najczęściej: $y=f'(x_0)(x-x_0)+f(x_0)$." },
      { q: "Co oznacza geometrycznie pochodna w punkcie?", a: "To nachylenie stycznej do wykresu funkcji w tym punkcie." },
      { q: "Kiedy styczna jest pozioma?", a: "Gdy $f'(x_0)=0$." },
      { q: "Jaki jest najczęstszy błąd przy zadaniach ze styczną?", a: "Podstawienie złej wartości punktu albo pomylenie $f(x_0)$ z $f'(x_0)$." },
    ],
  },
  ...basicSchoolSeoTopicRegistry,
  ...expandedSeoTopicRegistry,
  ...maturaSeoTopicRegistry,
];

const TASK_SUFFIX = "-zadania";
const existingSlugs = new Set(
  seoTopicRegistry.map((topic) => String(topic?.slug || "").trim()).filter(Boolean)
);

const generatedTaskEntries = seoTopicRegistry
  .filter((topic) => {
    const slug = String(topic?.slug || "").trim();
    if (topic?.skipTaskVariant) return false;
    return slug && !slug.endsWith(TASK_SUFFIX);
  })
  .map((topic) => {
    const baseSlug = String(topic.slug).trim();
    const baseTitle = String(topic.title || baseSlug).trim();
    const taskSlug = `${baseSlug}${TASK_SUFFIX}`;

    return {
      slug: taskSlug,
      lessonId: topic.lessonId,
      title: `${baseTitle} - zadania (\u0107wiczenia online)`,
      useRealTheory: false,
      directPartIndex: 1,
    };
  })
  .filter((entry) => !existingSlugs.has(entry.slug));

seoTopicRegistry.push(...generatedTaskEntries);

for (const topic of seoTopicRegistry) {
  const slug = String(topic?.slug || "");
  if (slug.endsWith(TASK_SUFFIX) && Object.prototype.hasOwnProperty.call(topic, "seoNote")) {
    delete topic.seoNote;
  }
}
